enum CommonApi {
  GET_PAYMENT_INIT_TOKEN = `protected/transaction/token/init`,
  FIND_SOCIAL_TEMPLATES_BY_REG = `registrationParticipant/socialPostTemplate/findByRegistrationId`,
  FIND_SOCIAL_TEMPLATES_PUBLIC = "public/registration/socialPostTemplate/findByRegistrationId",
  CREATE_SCHEMA_FIELD_ASSET = "resourceAsset/create",
  GET_TIME_SESSION_BY_PROGRAM_ORGANIZATION = "programOrganization/fetchMeetingRepAvailability",
  UPDATE_MEETING_REP_AVAILABILITY = "programOrganization/meetingRepAvailability/createOrUpdate",
  REFETCH_PURCHASE_ORDER_DETAILS = `protected/transaction/validateInitToken`,

  ASSOCIATE_PROGRAM_SEARCH_PARTICIPANT = "eventParticipant/searchByNameOrOrgNameForActivity",
  RESEND_CAL_INVITE_FOR_PARTICIPATION = "activity/sendInviteEmail",
  PAYMENT_BY_INVOICE_PAYER_REQUEST = "protected/transaction/invoicePayer",
  PAYMENT_BY_INVOICE_PAYER_GET_TRANSACTION_BY_ID = "protected/invoicePaymentRequest/findById",
  RESEND_INVOICE_PAYMENT_REMINDER_TO_PAYER = "protected/invoicePaymentRequest/resumeInvoicePaymentRequest",
  DOWNLOAD_API_RESOURCE_ASSET = "resourceAsset/download/{id}",
  BULK_TICKET_LOT_TRANSFER = "bulkTicket/transfer",
  DOWNLOAD_EVENT_SUMMARY = "eventParticipant/downloadPostEventSummary",
  FIND_NON_ATTENDEE_REGISTRATION = "participant/registration/findNonAttendeeRegistration",
  FETCH_FIELDS_BY_VIEWTYPE = `participant/registration/findRegistrationFieldsForViewType`,
  INITIATE_TICKET_TRANSFER = `participant/registration/initiateByTicketTransfer`,
  INITIATE_TICKET_TRANSFER_TO_NON_ATTENDEE = `ticket/transfer/initiateTransferToNonAttendee`,
  CANCEL_TICKET_TRANSFER = `ticket/transfer/cancel/{registrationParticipantId}`
}

export default CommonApi;
